import {fetchPokusDataThunk} from '@stencil/hotels-common-reducer/src/thunks';
import {
  fetchPokusDataStatusSelectorFn,
  pokusExpDataSelectorFn,
} from '@stencil/hotels-common-reducer/src/selectors';
import {useState, useEffect, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FetchStatusType} from '@stencil/hotels-cg-reducer/src/details/types';

export default function handlePokusLoad(platform, channel = '') {
  const dispatch = useDispatch();
  const [pokusRetryCount, setPokusRetryCount] = useState(0);
  const pokusExpData = useSelector(pokusExpDataSelectorFn);
  const pokusDataStatus = useSelector(fetchPokusDataStatusSelectorFn);
  const PokusMaxRetryCount = 2;

  const fetchPokusData = useCallback(() => {
    return dispatch(fetchPokusDataThunk(platform, channel));
  }, [dispatch]);

  useEffect(() => {
    let isSubscribed = true;

    if (
      !Object.keys(pokusExpData).length &&
      pokusRetryCount < PokusMaxRetryCount &&
      (pokusDataStatus === FetchStatusType.NOT_STARTED ||
        pokusDataStatus === FetchStatusType.REJECTED)
    ) {
      setPokusRetryCount(pokusRetryCount + 1);
      isSubscribed && fetchPokusData();
    }

    // Cancelling async task on unmount
    return () => {
      isSubscribed = false;
    };
  }, [pokusExpData, pokusDataStatus]);
}
